// src/components/ColorWorksManagement.jsx
import React, { useState, useEffect } from 'react';
import {
    Table,
    Button,
    Form,
    Input,
    Select,
    Tag,
    Space,
    Card,
    Typography,
    message,
    Row,
    Col,
    Image,
    Modal,
    Switch
} from 'antd';
import {
    EyeOutlined
} from '@ant-design/icons';
import moment from 'moment';
// 模拟数据服务，后续替换为真实apiService
//import mockApiService from '../services/mockApi';
import apiService from "../services/api";

const { Title } = Typography;
const { Option } = Select;
const { TextArea } = Input;

// 数据服务切换点 - 后续只需修改这里即可切换数据源
//const dataService = mockApiService; // 后续改为 apiService

const ColorWorksManagement = () => {
    const [works, setWorks] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 5,
        total: 0
    });
    const [filterForm] = Form.useForm();
    const [detailModalVisible, setDetailModalVisible] = useState(false);
    const [selectedWork, setSelectedWork] = useState(null);
    const [customDescription, setCustomDescription] = useState('');
    const [users, setUsers] = useState([]);

    useEffect(() => {
        loadWorks();
        loadUsers()
    }, []);

    const loadUsers = async () => {
        try {
            // 使用当前数据服务获取数据
            // const response = await dataService.users.getList();
            const response = await apiService.colorRecord.getRecordUserList();
            if (response.code === 200) {
                setUsers(response.data.users);
            } else {
                throw new Error(response.message);
            }
        } catch (error) {
            message.error('获取用户列表失败: ' + error.message);
        }
    };

    const loadWorks = async (page = 1, pageSize = 5, filters = {}) => {
        setLoading(true);
        try {
            // 使用当前数据服务获取数据
            // const response = await dataService.colorWorks.getList(page, pageSize);
            console.log("请求参数", page, pageSize, filters)
            const response = await apiService.colorRecord.getColorRecordList(page, pageSize,filters.userId);
            if (response.code === 200) {
                let filteredRecords = response.data.records;

                // 应用用户筛选
                if (filters.userName) {
                    filteredRecords = filteredRecords.filter(work => work.userName === filters.userName);
                }

                setWorks(filteredRecords.map(work => ({
                    ...work,
                    key: work.id
                })));

                setPagination({
                    ...pagination,
                    current: response.data.current,
                    pageSize: response.data.size,
                    total: response.data.total
                });

                console.log("当前分页参数", pagination)
            } else {
                throw new Error(response.message);
            }
        } catch (error) {
            message.error('获取调色作品列表失败: ' + error.message);
        } finally {
            setLoading(false);
        }
    };

    // 在组件内部添加一个辅助函数来处理图片URL
    const getImageUrl = (imagePath) => {
        // 如果imagePath为空或未定义，返回默认图片
        if (!imagePath) {
            return 'https://images.unsplash.com/photo-1590602847861-f357b3b46c8d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80';
        }

        // 如果已经是完整的URL（包含http或https），直接返回
        if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
            return imagePath;
        }

        // 如果是相对路径，添加baseURL前缀
        if (imagePath.startsWith('/')) {
            return apiService.baseURL.replace('/api', '') + imagePath;
        }

        // 其他情况，也添加baseURL前缀
        return apiService.baseURL.replace('/api', '') + '/' + imagePath;
    };

    const handleTableChange = (pagination) => {
        const filters = filterForm.getFieldsValue();
        loadWorks(pagination.current, pagination.pageSize, filters);
    };

    // 处理筛选
    const handleFilter = (values) => {
        console.log("筛选参数", values)
        loadWorks(1, pagination.pageSize, values);
    };

    // 重置筛选
    const handleReset = () => {
        filterForm.resetFields();
        loadWorks(1, pagination.pageSize, {});
    };

    // 切换优秀作品状态
    const toggleFeatured = async (id, isFeatured) => {
        try {
            // const formData = new FormData();
            // formData.append('id', id);
            // formData.append('isFeatured', isFeatured ? 1 : 0);

            // const response = await dataService.colorWorks.update(formData);
            const response = await apiService.colorRecord.updateFeatured(id,isFeatured ? 1 : 0);
            if (response.code === 200) {
                message.success('更新优秀作品状态成功');
                // 更新当前列表中的状态
                setWorks(works.map(work =>
                    work.id === id ? {...work, isFeatured: isFeatured ? 1 : 0} : work
                ));
            } else {
                throw new Error(response.message);
            }
        } catch (error) {
            message.error('更新优秀作品状态失败: ' + error.message);
        }
    };

    // 查看详情
    const handleViewDetail = async (id) => {
        try {
            const response = await apiService.colorRecord.getColorRecordDetail(id);
            if (response.code === 200) {
                setSelectedWork(response.data);
                // 初始化自定义描述为原始描述
                setCustomDescription(response.data.description || '');
                setDetailModalVisible(true);
            } else {
                throw new Error(response.message);
            }
        } catch (error) {
            message.error('获取作品详情失败: ' + error.message);
        }
    };

    // 关闭详情模态框
    const handleDetailModalCancel = () => {
        setDetailModalVisible(false);
        setSelectedWork(null);
        setCustomDescription('');
    };

    // 删除作品
    const handleDelete = async (id) => {
        try {
            const response = await apiService.colorRecord.deleteColorRecord(id);
            if (response.code === 200) {
                message.success('删除成功');
                // 重新加载列表
                loadWorks(pagination.current, pagination.pageSize, filterForm.getFieldsValue());
            } else {
                throw new Error(response.message);
            }
        } catch (error) {
            message.error('删除失败: ' + error.message);
        }
    };


    // 保存自定义描述
    // 保存自定义描述
    const handleSaveCustomDescription = async () => {
        if (!selectedWork) {
            message.error('未选择作品');
            return;
        }

        try {
            // 使用 FormData 格式（如果后端需要）
            // const formData = new FormData();
            // formData.append('id', selectedWork.id);
            // formData.append('description', customDescription);

            const response = await apiService.colorRecord.updateCustomDescription(selectedWork.id,customDescription);

            if (response.code === 200) {
                setWorks(works.map(work =>
                    work.id === selectedWork.id ? {...work, description: customDescription} : work
                ));
            }
            else {
                throw new Error(response.message);
            }

            message.success('自定义描述已保存');
            console.log('保存的自定义描述:', customDescription);
            console.log('作品ID:', selectedWork.id);
        } catch (error) {
            message.error('保存描述失败: ' + error.message);
        }
    };


    const columns = [
        {
            title: '作品标题',
            dataIndex: 'title',
            key: 'title',
        },
        {
            title: '配方名称',
            dataIndex: 'formula',
            key: 'formula',
        },
        {
            title: '配方图片',
            dataIndex: 'formulaImage',
            key: 'formulaImage',
            render: (formulaImage) => formulaImage ? (
                <Image
                    width={50}
                    src={formulaImage}
                    alt="配方图片"
                />
            ) : '无'
        },
        {
            title: '染之前图片',
            dataIndex: 'beforeImage',
            key: 'beforeImage',
            render: (beforeImage) => beforeImage ? (
                <Image
                    width={50}
                    src={getImageUrl(beforeImage)}
                    alt="染之前图片"
                />
            ) : '无'
        },
        {
            title: '染之后图片',
            dataIndex: 'afterImage',
            key: 'afterImage',
            render: (afterImage) => afterImage ? (
                <Image
                    width={50}
                    src={getImageUrl(afterImage)}
                    alt="染之后图片"
                />
            ) : '无'
        },
        {
            title: '所属用户',
            dataIndex: 'userName',
            key: 'userName',
        },
        {
            title: '作者',
            dataIndex: 'author',
            key: 'author',
        },
        {
            title: '是否为优秀作品',
            dataIndex: 'isFeatured',
            key: 'isFeatured',
            render: (isFeatured, record) => (
                <Switch
                    checked={isFeatured === 1}
                    onChange={(checked) => toggleFeatured(record.id, checked)}
                    checkedChildren="是"
                    unCheckedChildren="否"
                />
            )
        },
        {
            title: '标签',
            dataIndex: 'tags',
            key: 'tags',
            render: (tags) => (
                <>
                    {tags && tags.map((tag, index) => (
                        <Tag color="blue" key={index}>{tag}</Tag>
                    ))}
                </>
            )
        },
        {
            title: '发布时间',
            dataIndex: 'time',
            key: 'time',
            render: (time) => time ? moment(time).format('YYYY-MM-DD HH:mm') : '未设置'
        },
        {
            title: '操作',
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <Button
                        icon={<EyeOutlined />}
                        size="small"
                        onClick={() => handleViewDetail(record.id)}
                    >
                        查看详情
                    </Button>
                    <Button
                        danger
                        size="small"
                        onClick={() => handleDelete(record.id)}
                    >
                        删除
                    </Button>
                </Space>
            ),
        },
    ];

    return (
        <Card>
            <Title level={4} style={{ marginBottom: 20 }}>优秀调色作品管理</Title>

            {/* 筛选表单 */}
            <Form
                form={filterForm}
                layout="inline"
                onFinish={handleFilter}
                style={{ marginBottom: 20 }}
            >
                <Row gutter={16} style={{ width: '100%' }}>
                    <Col span={6}>
                        <Form.Item
                            name="userId"
                            label="所属用户"
                        >
                            <Select
                                placeholder="请选择用户"
                                allowClear
                            >
                                <Option value="">全部用户</Option>
                                {users.map(user => (
                                    <Option key={user.id} value={user.id}>
                                        {user.userName}
                                    </Option>
                                ))}
                            </Select>

                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item>
                            <Space>
                                <Button type="primary" htmlType="submit">
                                    筛选
                                </Button>
                                <Button onClick={handleReset}>
                                    重置
                                </Button>
                            </Space>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>

            <Table
                dataSource={works}
                columns={columns}
                loading={loading}
                pagination={pagination}
                onChange={handleTableChange}
                scroll={{ x: 1200 }}
            />

            {/* 详情模态框 */}
            <Modal
                title="调色作品详情"
                visible={detailModalVisible}
                onCancel={handleDetailModalCancel}
                footer={null}
                width={800}
            >
                {selectedWork && (
                    <div>
                        <Row gutter={16}>
                            <Col span={12}>
                                <h3>作品信息</h3>
                                <p><strong>作品标题：</strong>{selectedWork.title}</p>
                                <p><strong>作者：</strong>{selectedWork.author}</p>
                                <p><strong>所属用户：</strong>{selectedWork.userName}</p>
                                <p><strong>配方名称：</strong>{selectedWork.formula}</p>
                                <p><strong>是否为优秀作品：</strong>
                                    <Tag color={selectedWork.isFeatured === 1 ? 'green' : 'default'}>
                                        {selectedWork.isFeatured === 1 ? '是' : '否'}
                                    </Tag>
                                </p>
                                <p><strong>发布时间：</strong>
                                    {selectedWork.time ? moment(selectedWork.time).format('YYYY-MM-DD HH:mm') : '未设置'}
                                </p>
                            </Col>
                            <Col span={12}>
                                <h3>配方图片</h3>
                                {selectedWork.formulaImage ? (
                                    <Image
                                        width={200}
                                        src={selectedWork.formulaImage}
                                        alt="配方图片"
                                    />
                                ) : (
                                    <p>无作品图片</p>
                                )}
                            </Col>
                        </Row>

                        <Row gutter={16} style={{ marginTop: 20 }}>
                            <Col span={24}>
                                <h3>自定义描述</h3>
                                <TextArea
                                    rows={4}
                                    value={customDescription}
                                    onChange={(e) => setCustomDescription(e.target.value)}
                                    placeholder="请输入自定义描述..."
                                />
                                <div style={{ marginTop: 10, textAlign: 'right' }}>
                                    <Button type="primary" onClick={handleSaveCustomDescription}>
                                        保存描述
                                    </Button>
                                </div>
                            </Col>
                        </Row>

                        <Row gutter={16} style={{ marginTop: 20 }}>
                            <Col span={8}>
                                <h4>染之前图片</h4>
                                {selectedWork.beforeImage ? (
                                    <Image
                                        width={150}
                                        src={selectedWork.beforeImage}
                                        alt="染之前"
                                    />
                                ) : (
                                    <p>无染之前图片</p>
                                )}
                            </Col>
                            <Col span={8}>
                                <h4>染之后图片</h4>
                                {selectedWork.afterImage ? (
                                    <Image
                                        width={150}
                                        src={getImageUrl(selectedWork.afterImage)}
                                        alt="染之后"
                                    />
                                ) : (
                                    <p>无染之后图片</p>
                                )}
                            </Col>
                        </Row>

                        <Row gutter={16} style={{ marginTop: 20 }}>
                            <Col span={24}>
                                <h3>标签</h3>
                                {selectedWork.tags && selectedWork.tags.length > 0 ? (
                                    selectedWork.tags.map((tag, index) => (
                                        <Tag color="blue" key={index}>{tag}</Tag>
                                    ))
                                ) : (
                                    <p>暂无标签</p>
                                )}
                            </Col>
                        </Row>
                    </div>
                )}
            </Modal>
        </Card>
    );
};

export default ColorWorksManagement;
